import React from 'react';

export enum demoReducerActions {
  SET_DEMO = 'SET_DEMO',
}

export enum flowType {
  'consent' = 'consent',
  'noConsent' = 'noConsent',
  'frictionless' = 'frictionless',
  'challengeDecline' = 'challengeDecline',
  'challengeSuccess' = 'challengeSuccess',
  'challengeFrictionless' = 'challengeFrictionless',
}

interface IAction {
  type: string;
  payload: any;
}

interface IState {
  flow: flowType;
}
type DemoProviderProps = { children: React.ReactNode };

const DemoStateContext = React.createContext<{ state: IState; dispatch: React.Dispatch<IAction> } | undefined>(
  undefined,
);

function demoReducer(state: IState, action: IAction) {
  switch (action.type) {
    case demoReducerActions.SET_DEMO: {
      return { ...state, flow: action.payload };
    }
    default: {
      return state;
    }
  }
}

function DemoProvider({ children }: DemoProviderProps) {
  const [state, dispatch] = React.useReducer(demoReducer, {
    flow: flowType.noConsent,
  });
  const value = { state, dispatch };

  return <DemoStateContext.Provider value={value}>{children}</DemoStateContext.Provider>;
}

function useDemo() {
  const context = React.useContext(DemoStateContext);
  if (context === undefined) {
    throw new Error('useDemo must be used within a DemoProvider');
  }
  return context;
}

export { DemoProvider, useDemo };
